module.exports = __webpack_public_path__ + "static/media/logistics.65210b29.svg";